import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Home from "../views/Home.vue";
import Ekancha from "@/views/product/ekancha.vue";
import Ytkc from "@/views/product/ytkc.vue";
import Automation from "@/views/product/automation.vue";
import Geology from "@/views/product/geology.vue";
import Infosys from "@/views/product/infosys.vue";
import About from "../views/About.vue";
import OpenAbility from "../views/OpenAbility.vue";
import Solve from "../views/solve.vue";
import Application from "../views/Application.vue";
import Gongcheng from "../views/scheme/gongcheng.vue";
import yantuai from "../views/product/yantuai.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/application",
    name: "application",
    component: Application,
  },
  {
    path: "/ekancha",
    name: "ekancha",
    component: Ekancha,
  },
  {
    path: "/ytkc",
    name: "Ytkc",
    component: Ytkc,
  },
  {
    path: "/automation",
    name: "Automation",
    component: Automation,
  },
  {
    path: "/geology",
    name: "Geology",
    component: Geology,
  },
  {
    path: "/infosys",
    name: "Infosys",
    component: Infosys,
  },
  {
    path: "/yantuai",
    name: "yantuai",
    component: yantuai,
  },
  {
    path: "/about",
    name: "about",
    component: About,
  },
  {
    path: "/solve",
    name: "solve",
    component: Solve,
  },
  {
    path: "/openAbility",
    name: "openAbility",
    component: OpenAbility,
  },
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/Gongcheng",
    name: "Gongcheng",
    component:Gongcheng,
  },

];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// router.beforeEach((to, from, next) => {
//   console.log(to,from,next)
// })

export default router;
